import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import type { RouteObject } from "react-router-dom";

const clusterDetailBreadcrumb = breadcrumbSlot();

export const pmAgentRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Redo PM" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { PmAgentPage } = await import("./pm-agent-page");
          return { Component: PmAgentPage };
        },
      },
      {
        path: "cluster/:clusterId",
        handle: { breadcrumb: clusterDetailBreadcrumb },
        async lazy() {
          const { ClusterDetailPage } = await import("./cluster-detail-page");
          return {
            element: <ClusterDetailPage breadcrumb={clusterDetailBreadcrumb} />,
          };
        },
      },
    ],
  },
];
